<script>
    import {handleMouseDown} from '../../../handlers/mouse/down';
    import {handleMouseMove} from '../../../handlers/mouse/move';
    import {handleMouseUp} from '../../../handlers/mouse/up';
    import {handleMouseWheel} from '../../../handlers/mouse/wheel';
    
</script>
<canvas class="text" 
on:mousedown={handleMouseDown} 
on:mousemove={handleMouseMove} 
on:mouseup={handleMouseUp}
on:mousewheel={handleMouseWheel}></canvas>
<style></style>